import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { NewbuildingsLink } from '../../components/NewbuildingsLink';

interface INewbuildingLinkContainerProps {
  desktopUrl: string;
  mobileUrl: string;
  onClick?(): void;
}

export const NewbuildingLinkContainer = ({ desktopUrl, mobileUrl, onClick }: INewbuildingLinkContainerProps) => {
  const deviceType = useDeviceType();

  const newbuildingsUrl = deviceType === 'desktop' ? desktopUrl : mobileUrl;

  const label = deviceType !== 'desktop' ? 'Смотреть объявления' : 'Смотреть ЖК по акции';

  return <NewbuildingsLink url={newbuildingsUrl} onClick={onClick} label={label} />;
};
